import { render } from "./PollDataTable.vue?vue&type=template&id=54f7b7e2"
import script from "./PollDataTable.vue?vue&type=script&lang=js"
export * from "./PollDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__